import {getGtmPageType} from '../helpers/gtm/getGtmPageType';
import {GTM_ATTRIBUTE_PAGE_READY} from '../helpers/gtm/gtmSelectors';

const gtmInit = () => {
    const analyticsData = JSON.parse(localStorage.getItem('analytics'));
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }

    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
      new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
      `${analyticsData?.gtm_url}/gtm.js?id=`+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', analyticsData?.gtm_id);

    const extractStreetNumbers = (str) => {
        const numbers = str.match(/\d+/g);

        return numbers ? numbers.join('') : '';
    };

    window.addEventListener('message', function(event) {
        if (event.data.type === 'Gtm_page_viewed') {
            const initData = event.data.initData;
            gtag('consent', 'update', {
                'ad_storage': initData.customerPrivacy.marketingAllowed ? 'granted' : 'denied',
                'analytics_storage': initData.customerPrivacy.analyticsProcessingAllowed ? 'granted' : 'denied',
                'ad_user_data': initData.customerPrivacy.saleOfDataAllowed ? 'granted' : 'denied',
                'ad_personalization': initData.customerPrivacy.marketingAllowed ? 'granted' : 'denied',
            });
            gtag('js', new Date());
            gtag('config', analyticsData?.gtm_id);

            const customerDefaultAddress = analyticsData?.customer_default_address;
            const pageType = getGtmPageType(window.ShopifyAnalytics.meta.page.pageType);

            window.dataLayer.push({
                event: 'page_ready',
                send_to: analyticsData?.gtm_id,
                page: {
                    type: pageType.type,
                    pageId: pageType.id,
                    articleId: analyticsData?.article_id,
                    authors: analyticsData?.authors,
                    flags: analyticsData?.article_tags ?? '',
                },
                user: {
                    id: initData.data.customer?.id ?? '',
                    type: initData.data.customer ? 'customer' : 'visitor',
                    email: initData.data.customer?.email ?? '',
                    firstName: customerDefaultAddress?.first_name ?? '',
                    lastName: customerDefaultAddress?.last_name ?? '',
                    telephone: customerDefaultAddress?.phone ?? '',
                    street: customerDefaultAddress?.address1 ?? '',
                    streetNumber: customerDefaultAddress?.address1 ?
                        extractStreetNumbers(customerDefaultAddress?.address1) : '',
                    city: customerDefaultAddress?.city ?? '',
                    postcode: customerDefaultAddress?.zip ?? '',
                    country: customerDefaultAddress?.country_code ?? '',
                },
                language: initData.data.shop.countryCode,
                currencyCode: initData.data.shop.paymentSettings.currencyCode,
                consent: {
                    analytics: initData.customerPrivacy.analyticsProcessingAllowed,
                    marketing: initData.customerPrivacy.marketingAllowed,
                },
                _clear: true,
            });

            setTimeout(() => {
                document.body.setAttribute(GTM_ATTRIBUTE_PAGE_READY, true);
            }, 0);
        }
    });
};

gtmInit();
